/* tslint:disable */
/* eslint-disable */
/**
 * crm
 * crm
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { EmailAddressBookItem } from './EmailAddressBookItem';
import {
    EmailAddressBookItemFromJSON,
    EmailAddressBookItemFromJSONTyped,
    EmailAddressBookItemToJSON,
} from './EmailAddressBookItem';

/**
 * 
 * @export
 * @interface FindAllEmailAddressBookResponse
 */
export interface FindAllEmailAddressBookResponse {
    /**
     * 
     * @type {Array<EmailAddressBookItem>}
     * @memberof FindAllEmailAddressBookResponse
     */
    data: Array<EmailAddressBookItem>;
    /**
     * 
     * @type {number}
     * @memberof FindAllEmailAddressBookResponse
     */
    total: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllEmailAddressBookResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof FindAllEmailAddressBookResponse
     */
    limit?: number;
    /**
     * 
     * @type {boolean}
     * @memberof FindAllEmailAddressBookResponse
     */
    has_next: boolean;
}

/**
 * Check if a given object implements the FindAllEmailAddressBookResponse interface.
 */
export function instanceOfFindAllEmailAddressBookResponse(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "data" in value;
    isInstance = isInstance && "total" in value;
    isInstance = isInstance && "has_next" in value;

    return isInstance;
}

export function FindAllEmailAddressBookResponseFromJSON(json: any): FindAllEmailAddressBookResponse {
    return FindAllEmailAddressBookResponseFromJSONTyped(json, false);
}

export function FindAllEmailAddressBookResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindAllEmailAddressBookResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': ((json['data'] as Array<any>).map(EmailAddressBookItemFromJSON)),
        'total': json['total'],
        'page': !exists(json, 'page') ? undefined : json['page'],
        'limit': !exists(json, 'limit') ? undefined : json['limit'],
        'has_next': json['has_next'],
    };
}

export function FindAllEmailAddressBookResponseToJSON(value?: FindAllEmailAddressBookResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': ((value.data as Array<any>).map(EmailAddressBookItemToJSON)),
        'total': value.total,
        'page': value.page,
        'limit': value.limit,
        'has_next': value.has_next,
    };
}

